package pt.at.oss.kotlin.pages.i18n

import pt.at.oss.kotlin.core.i18n.I18nBase
import pt.at.oss.kotlin.core.i18n.PageLocale

enum class ExclusoesI18n(override val translations: Map<PageLocale, String>) : I18nBase {

    FORM_TITLE(
        mapOf(
            PageLocale.PT to "Pedido de Exclusão",
            PageLocale.EN to "Exclusion Request"
        )
    ),
    FORM_SUBTITLE(
        mapOf(
            PageLocale.PT to "Estou a pedir exclusão do regime especial porque:",
            PageLocale.EN to "I request exclusion from the special scheme because:"
        )
    ),

    CODE_1_UNION(
        mapOf(
            PageLocale.PT to "Já não forneço bens ou serviços.",
            PageLocale.EN to "I no longer supply goods or services."
        )
    ),
    CODE_1_NON_UNION(
        mapOf(
            PageLocale.PT to "Já não presto serviços.",
            PageLocale.EN to "I no longer supply services."
        )
    ),
    CODE_1_IMPORT(
        mapOf(
            PageLocale.PT to "Já não forneço bens.",
            PageLocale.EN to "I no longer supply goods."
        )
    ),

    CODE_5(
        mapOf(
            PageLocale.PT to "Pretendo sair voluntariamente do regime especial.",
            PageLocale.EN to "I request to leave the special scheme voluntarily."
        )
    ),
    CODE_5_MOTIVE(
        mapOf(
            PageLocale.PT to "Qual o motivo?",
            PageLocale.EN to "Please specify"
        )
    ),
    CODE_5_DATE_TEXT(
        mapOf(
            PageLocale.PT to "Quando pretende deixar de utilizar este regime?",
            PageLocale.EN to "When do you intend to cease using the special scheme?"
        )
    ),
    CODE_5_IMPORT_END_DATE_LABEL(
        mapOf(
            PageLocale.PT to "Data até quando o número de identificação de IVA IOSS permanecerá válido para permitir a entrada de mercadorias anteriormente fornecidas para a UE.",
            PageLocale.EN to "Date until when the IOSS VAT Identification number shall remain valid to allow goods previously supplied to enter in the EU."
        )
    ),

    CODE_6(
        mapOf(
            PageLocale.PT to "Pretendo passar a ser identificado por um novo Estado-Membro.",
            PageLocale.EN to "I request to be identified in a new Member State."
        )
    ),
    CODE_6_LEAVE_COUNTRY_SCHEME(
        mapOf(
            PageLocale.PT to "A minha empresa não tem sede na União Europeia e tem estabelecimentos estáveis em vários Estados-Membros. Desejo ser identificado noutro Estado-Membro. Já se passaram pelo menos dois anos desde que me registei no OSS em Portugal.",
            PageLocale.EN to "My business is not established in the Union and I wish to be identified in another Member State in which I have a fixed establishment and it is at least two years since I registered for OSS in Portugal."
        )
    ),
    CODE_6_DATE_LEAVE_COUNTRY_SCHEME(
        mapOf(
            PageLocale.PT to "Quando pretende deixar de utilizar o regime especial em Portugal?",
            PageLocale.EN to "When do you intend to cease using the special scheme in our country?"
        )
    ),
    CODE_6_CEASED_TO_HAVE_FE(
        mapOf(
            PageLocale.PT to "A minha empresa não tem sede na União Europeia e deixou de ter um estabelecimento estável em Portugal. Desejo continuar a utilizar o regime especial inscrevendo-me noutro Estado-Membro onde tenha um estabelecimento estável.",
            PageLocale.EN to "My business is not established in the Union and has ceased to have a fixed establishment in Portugal. We wish to continue to use the special scheme by registering in another Member State in which we have a fixed establishment."
        )
    ),
    CODE_6_DATE_CEASED_TO_HAVE_FE(
        mapOf(
            PageLocale.PT to "Quando deixou de ter um estabelecimento estável em Portugal?",
            PageLocale.EN to "When did you ceased to have a fixed establishment in Portugal?"
        )
    ),

    CODE_6_CHANGE_FE_FOR_MSID(
        mapOf(
            PageLocale.PT to "A minha empresa tem sede na União Europeia e mudou a morada da sede de Portugal para outro Estado-Membro.",
            PageLocale.EN to "My business is established in the Union and has moved its place of establishment from Portugal to another Member State."
        )
    ),
    CODE_6_DATE_CHANGE_FE_FOR_MSID(
        mapOf(
            PageLocale.PT to "Quando é que alterou a morada do seu estabelecimento em Portugal?",
            PageLocale.EN to "When did you move your place of business from Portugal?"
        )
    ),

    CODE_3(
        mapOf(
            PageLocale.PT to "Já não possuo as condições necessárias para continuar a utilizar este regime especial.",
            PageLocale.EN to "I no longer meet the conditions necessary to use this special scheme."
        )
    ),
    CODE_3_NON_UNION_STATEMENT(
        mapOf(
            PageLocale.PT to "Um vez que possuo um estabelecimento estável na União Europeia.",
            PageLocale.EN to "Because I have established in the Union."
        )
    ),

    CODE_3_IMPORT_STATEMENT(
        mapOf(
            PageLocale.PT to "Pelo seguinte motivo:",
            PageLocale.EN to "By the following motive:"
        )
    ),
    CODE_3_END_DATE_TEXT(
        mapOf(
            PageLocale.PT to "Quando deixa de reunir as condições necessárias?",
            PageLocale.EN to "When do you no longer meet the conditions necessary?"
        )
    ),
    // Import - No longer meet conditions - motives
    CODE_3_IMPORT_MOTIVE_HAS_ESTAB(
        mapOf(
            PageLocale.PT to "Passei a ter sede ou estabelecimento estável na União.",
            PageLocale.EN to "I am now established or have a fixed establishment in the Union."
        )
    ),
    CODE_3_IMPORT_MOTIVE_NOT_REPRESENTED(
        mapOf(
            PageLocale.PT to "Deixei de ser representado por Intermediário.",
            PageLocale.EN to "I am no longer represented by an Intermediary."
        )
    ),

    EXCLUSION_EFFECTIVE_DATE_LABEL(
        mapOf(
            PageLocale.PT to "Data em que a Exclusão entrará em vigor.",
            PageLocale.EN to "Date on which the Exclusion will take effect."
        )
    ),

    PROVIDE_VATID_AND_COUNTRY(
        mapOf(
            PageLocale.PT to "Por favor forneça-nos o seu pais de identificação e número de identificação no regime especial:",
            PageLocale.EN to "Please provide your new member-state of identification and special scheme number:"
        )
    ),
    VATID_ISSUING_COUNTRY(
        mapOf(
            PageLocale.PT to "Estado-Membro de identificação",
            PageLocale.EN to "Identification Country"
        )
    ),
    VATID_VATNUM(
        mapOf(
            PageLocale.PT to "Número no regime especial",
            PageLocale.EN to "VAT Number in the special scheme"
        )
    ),

    PROVIDE_VATID_AND_COUNTRY_IOSS(
        mapOf(
            PageLocale.PT to "Por favor forneça-nos o seu novo estado-membro de identificação e número IVA:",
            PageLocale.EN to "Please provide your new member-state of identification and VAT/TIN Number:"
        )
    ),
    VATID_VATNUM_IOSS(
        mapOf(
            PageLocale.PT to "Número IVA",
            PageLocale.EN to "VAT Number"
        )
    ),

    SUBMIT(
        mapOf(
            PageLocale.PT to "Submeter",
            PageLocale.EN to "Submit"
        )
    ),
    CONFIRM_MODAL_TEXT(
        mapOf(
            PageLocale.PT to "Confirmo que pretendo efetuar pedido de exclusão neste regime especial.",
            PageLocale.EN to "I confirm that I wish to request my exclusion from this special scheme."
        )
    ),
    CONFIRM_BTN(
        mapOf(
            PageLocale.PT to "Confirmar",
            PageLocale.EN to "Confirm"
        )
    ),
    CANCEL_BTN(
        mapOf(
            PageLocale.PT to "Cancelar",
            PageLocale.EN to "Cancel"
        )
    )
}
